import { Route } from '@angular/router';
import { MyProjectsDeactivateGuard } from './guards/my-projects-deactivate.guard';
import { LandingComponent } from './catalogue/landing/landing.component';
import { ConsumerHomeComponent } from './consumer/home/home.component';
import { ConsumerSupportComponent } from './consumer/support/support.component';
import { ConsumerActivitiesComponent } from './consumer/activities/activities.component';
import { MyRequestComponent } from './consumer/my-request/my-request.component';
import { ConversationComponent } from './shared/components/conversation/conversation.component';
import { ConsumerProfileComponent } from './consumer/profile/profile.component';
import { ConsumerDelegateComponent } from './consumer/delegate/delegate.component';
import { ConsumerMyProjectsComponent } from './consumer/my-projects/my-projects.component';
import { ConsumerJoinOrganisationComponent } from './consumer/join-organisation/join-organisation.component';
import { ConsumerCreateOrganisationComponent } from './consumer/create-organisation/create-organisation.component';
import { ConsumerDataProviderEntityComponent } from './consumer/data-provider-entity/data-provider-entity.component';
import { ProviderHomeComponent } from './provider/home/home.component';
import { ProviderDashboardComponent } from './provider/dashboard/dashboard.component';
import { ProviderActivitiesComponent } from './provider/activities/activities.component';
import { ProviderProfileComponent } from './provider/profile/profile.component';
import { ProviderDelegateComponent } from './provider/delegate/delegate.component';
import { ProviderManageContributionComponent } from './provider/manage-contribution/manage-contribution.component';
import { ProviderAddDatasetComponent } from './provider/add-contributions/add-dataset/add-dataset.component';
import { ProviderAddDatasetNewComponent } from './provider/add-contributions/add-dataset-new/add-dataset-new.component';
import { ProviderAddModelComponent } from './provider/add-contributions/add-model/add-model.component';
import { ProviderMetadataComponent } from './shared/components/contribution-steps/metadata/metadata.component';
import { ProviderUploadMetadataComponent } from './shared/components/contribution-steps/upload-metadata/upload-metadata.component';
import { ProviderPreviewMetadataComponent } from './shared/components/contribution-steps/preview-metadata/preview-metadata.component';
import { ProviderAdditionalInfoComponent } from './shared/components/contribution-steps/additional-info/additionalInfo.component';
import { ProviderUploadComponent } from './shared/components/contribution-steps/upload/upload.component';
import { ProviderAccessRequestsComponent } from './provider/access-requests/access-requests.component';
import { ProviderDataProviderEntityComponent } from './provider/data-provider-entity/data-provider-entity.component';
import { ProviderSupportComponent } from './provider/support/support.component';
import { ProviderMyProjectsComponent } from './provider/my-projects/my-projects.component';
import { ProviderMyRequestComponent } from './provider/my-request/my-request.component';
import { OrgAdminHomeComponent } from './org-admin/home/home.component';
import { OrgAdminDashboardComponent } from './org-admin/dashboard/dashboard.component';
import { OrgAdminActivitiesComponent } from './org-admin/activities/activities.component';
import { OrgAdminAddContributionsComponent } from './org-admin/add-contributions/add-contributions.component';
import { OrgAdminMdmComponent } from './org-admin/mdm/mdm.component';
import { OrgAdminDelegateComponent } from './org-admin/delegate/delegate.component';
import { OrgAdminViewAllUsersComponent } from './org-admin/view-all-users/view-all-users.component';
import { UserRequestsHomeComponent } from './org-admin/user-requests/home/home.component';
import { OrgAdminManageContributionsComponent } from './org-admin/manage-contributions/manage-contributions.component';
import { AddPolicyHomeComponent } from './org-admin/add-policy-home/add-policy-home.component';
import { AccessRequestsHomeComponent } from './org-admin/access-requests/access-requests-home.component';
import { OrgAdminOrganisationActivitiesComponent } from './org-admin/organisation-activities/organisation-activities.component';
import { OrgAdminDataProviderEntityComponent } from './org-admin/data-provider-entity/data-provider-entity.component';
import { OrgAdminProfileComponent } from './org-admin/profile/profile.component';
import { OrgAdminSupportComponent } from './org-admin/support/support.component';
import { OrgAdminMyProjectsComponent } from './org-admin/my-projects/my-projects.component';
import { OrgAdminMyRequestComponent } from './org-admin/my-request/my-request.component';
import { OrgAdminAddDatasetComponent } from './org-admin/add-dataset/add-dataset.component';
import { OrgAdminAddDatasetNewComponent } from './org-admin/add-dataset-new/add-dataset-new.component';
import { OrgAdminAddModelComponent } from './org-admin/add-model/add-model.component';
import { AdminHomeComponent } from './platform-admin/home/home.component';
import { AdminDashboardComponent } from './platform-admin/dashboard/dashboard.component';
import { AdminActivitiesComponent } from './platform-admin/activities/activities.component';
import { AdminUserActivitiesComponent } from './platform-admin/user-activities/user-activities.component';
import { UserActivitiesHomeComponent } from './platform-admin/user-activities/user-activities-home/user-activities-home.component';
import { AdminAddContributionsComponent } from './platform-admin/add-contributions/add-contributions.component';
import { AdminViewAllUsersComponent } from './platform-admin/view-all-users/view-all-users.component';
import { AdminContributionsComponent } from './platform-admin/contributions/contributions.component';
import { AdminDataUploadRequestsHomeComponent } from './platform-admin/data-upload-requests/data-upload-requests-home/data-upload-requests-home.component';
import { AdminExistingEntitiesComponent } from './platform-admin/existing-entities/existing-entities.component';
import { AdminNewRequestsComponent } from './platform-admin/new-requests/new-requests.component';
import { AdminChallengeComponent } from './platform-admin/challenge/challenge.component';
import { ChallengeHomeComponent } from './platform-admin/challenge/challenge-home/challenge-home.component';
import { DiscussionHomeComponent } from './platform-admin/discussion/discussion-home/discussion-home.component';
import { AdminProfileComponent } from './platform-admin/profile/profile.component';
import { AdminDelegateComponent } from './platform-admin/delegate/delegate.component';
import { AdminSupportComponent } from './platform-admin/support/support.component';
import { ComputeCreditHomeComponent } from './platform-admin/credit-compute/compute-credit-home/compute-credit-home.component';
import { AdminAccessRequestsComponent } from './platform-admin/access-requests/access-requests.component';
import { AdminManageFeedbackComponent } from './platform-admin/manage-feedback/manage-feedback.component';

import { AdminSupersetDashboardComponent } from './platform-admin/superset-dashboard/superset-dashboard.component';
import { AboutUsHomeComponent } from './catalogue/about-us/home/home.component';
import { PrivacyPolicyComponent } from './catalogue/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './catalogue/terms-of-service/terms-of-service.component';
import { ContactUsComponent } from './catalogue/contact-us/contact-us.component';
import { ContactThankYouComponent } from './catalogue/contact-us/thank-you/thank-you.component';
import { DatasetsComponent } from './catalogue/datasets/datasets.component';
import { ModelsComponent } from './catalogue/models/models.component';
import { UsecasesComponent } from './catalogue/usecases/usecases.component';
import { LeadershipComponent } from './catalogue/leadership/leadership.component';
import { ChallengesHomeComponent } from './catalogue/challenges/home/home.component';
import { ChallengeDetailComponent } from './catalogue/challenges/detail/detail.component';
import { ChallengeCardDemoComponent } from './catalogue/challenges/challenge-card-demo/challenge-card-demo.component';
import { DiscussionHomeComponent as CatalogueDiscussionHomeComponent } from './catalogue/discussions/discussion-home/discussion-home.component';
import { DiscussionDetailComponent } from './catalogue/discussions/detail/detail.component';
import { DiscussionCreateComponent } from './catalogue/discussions/create/create.component';
import { DiscussionGettingStartedComponent } from './catalogue/discussions/categories/getting-started/getting-started.component';
import { DiscussionPublicComponent } from './catalogue/discussions/categories/public/public.component';
import { DiscussionGeneralComponent } from './catalogue/discussions/categories/general/general.component';
import { DiscussionFeedbackComponent } from './catalogue/discussions/categories/feedback/feedback.component';
import { DiscussionAnnouncementComponent } from './catalogue/discussions/categories/announcement/announcement.component';
import { DiscussionMyDiscussionsComponent } from './catalogue/discussions/personalise/my-discussions/my-discussions.component';
import { DiscussionMyBookmarksComponent } from './catalogue/discussions/personalise/my-bookmarks/my-bookmarks.component';
import { DiscussionPostSubmissionComponent } from './catalogue/discussions/personalise/post-submission/post-submission.component';
import { DiscussionMyPinnedComponent } from './catalogue/discussions/personalise/my-pinned/my-pinned.component';
import { DatasetDetailComponent } from './catalogue/dataset/detail/detail.component';
import { DatasetComingSoonComponent } from './catalogue/dataset/detail/coming-soon.component';
import { ComingSoonComponent } from './shared/components/coming-soon/coming-soon.component';
import { AdminComingSoonComponent } from './platform-admin/admin-coming-soon/admin-coming-soon.component';
import { ModelDetailComponent } from './catalogue/model/detail/detail.component';
import { SandboxComponent } from './catalogue/sandbox/sandbox.component';
import { ToolkitComponent } from './catalogue/toolkit/toolkit.component';
import { LibrariesComponent } from './catalogue/libraries/libraries.component';
import { KnowledgeHubComponent } from './catalogue/knowledge-hub/knowledge-hub.component';
import { UsecasesHomeComponent } from './shared/components/onboarding-assets/Usecases/usecases-home/usecases-home.component';
import { UserManualOverviewComponent } from './shared/components/user-manual/user-manual-overview.component';
import { UserManualSectionComponent } from './shared/components/user-manual/user-manual-section.component';
import { authGuard } from './guards/auth.guard';
import { delegateRestrictedRouteGuard } from './guards/delegate-restricted-route.guard';
import { isDelegateRestrictedPath } from './utils/delegate-restricted-routes.util';
import { RoleRedirectComponent } from './shared/components/role-redirect/role-redirect.component';

export const appRoutes: Route[] = [
  {
    path: 'dashboard',
    children: [
      { path: 'provider', redirectTo: '/provider/home', pathMatch: 'full' },
    ],
  },
  {
    path: 'consumer',
    component: RoleRedirectComponent,
    // Note: authGuard is not needed here as RoleRedirectComponent handles authentication
    // and redirects unauthenticated users to home page
  },
  {
    path: 'consumer/home',
    component: ConsumerHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Dashboard',
      description: 'Welcome !!',
    },
  },
  {
    path: 'consumer/activities',
    component: ConsumerActivitiesComponent,
    canActivate: [authGuard],
    data: {
      title: 'My Activities',
      description:
        'Shows the list of activities that the logged-in user has performed across the platform.',
    },
  },
  {
    path: 'consumer/support',
    component: ConsumerSupportComponent,
    canActivate: [authGuard],
    data: {
      title: 'Support Center',
      description:
        'Get help and find resources to make the most of your experience',
    },
  },
  {
    path: 'consumer/requests',
    component: MyRequestComponent,
    canActivate: [authGuard],
    data: {
      title: 'Asset Details',
      description: 'View and Manage your access requests',
    },
  },
  {
    path: 'consumer/requests/:requestId/conversation',
    component: ConversationComponent,
    canActivate: [authGuard],
    data: {
      title: 'Conversation',
      description: 'Discuss your request directly with an asset owner.',
      panel: 'consumer',
      role: 'requester',
      backRoute: '/consumer/requests',
    },
  },
  {
    path: 'consumer/profile',
    component: ConsumerProfileComponent,
    canActivate: [authGuard],
    data: {
      title: 'My Profile',
      description: 'Manage your account settings and preferences',
    },
  },
  {
    path: 'consumer/delegate',
    component: ConsumerDelegateComponent,
    canActivate: [authGuard],
    data: {
      title: 'Manage Delegate',
      description:
        "Delegation lets another user act on your behalf within scopes you already hold — it never changes anyone's primary role.",
    },
  },
  {
    path: 'consumer/delegation-activities',
    component: ConsumerActivitiesComponent,
    canActivate: [authGuard],
    data: {
      title: 'Delegate Activities',
      description:
        'Activities your delegates performed on assets and user actions.',
      hideComputeTab: true,
      actorType: 'DELEGATE',
    },
  },
  {
    path: 'consumer/delegated-access',
    component: ConsumerDelegateComponent,
    canActivate: [authGuard],
    data: {
      title: 'Delegated Access',
      description:
        'See the owners who granted you access and the scopes you can act on their behalf.',
      ownersOnly: true,
    },
  },
  {
    path: 'consumer/my-projects',
    component: ConsumerMyProjectsComponent,
    canActivate: [authGuard],
    canDeactivate: [MyProjectsDeactivateGuard],
    data: {
      title: 'My Projects',
      description: 'Manage and view all your projects',
    },
  },
  {
    path: 'consumer/join-organisation',
    component: ConsumerJoinOrganisationComponent,
    canActivate: [authGuard],
    data: {
      title: 'Join An Organisation',
      description:
        'Register or Join a Organisation on the MahaAgX to begin contributing Datasets, Models, Use Cases',
    },
  },
  {
    path: 'consumer/create-organisation',
    component: ConsumerCreateOrganisationComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create new Organisation',
      description:
        'Register or Join a Organisation on the MahaAgX to begin contributing Datasets, Models, Use Cases',
    },
  },
  {
    path: 'consumer/data-provider-entity',
    component: ConsumerDataProviderEntityComponent,
    canActivate: [authGuard],
    data: {
      title: 'Organisation',
      description: 'View your organisation details',
    },
  },
  {
    path: 'provider',
    component: RoleRedirectComponent,
    // Note: authGuard is not needed here as RoleRedirectComponent handles authentication
    // and redirects unauthenticated users to home page
  },
  {
    path: 'provider/home',
    component: ProviderHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Dashboard',
      description: 'Welcome !!',
    },
  },
  {
    path: 'provider/dashboard',
    component: ProviderDashboardComponent,
    canActivate: [authGuard],
    data: {
      title: 'Dashboard',
      description: 'Provider dashboard overview',
    },
  },
  {
    path: 'provider/activities',
    component: ProviderActivitiesComponent,
    canActivate: [authGuard],
    data: {
      title: 'My Activities',
      description: 'View and manage your activities',
    },
  },
  {
    path: 'provider/profile',
    component: ProviderProfileComponent,
    canActivate: [authGuard],
    data: {
      title: 'My Profile',
      description: 'Manage your account settings and preferences',
    },
  },
  {
    path: 'provider/delegate',
    component: ProviderDelegateComponent,
    canActivate: [authGuard],
    data: {
      title: 'Manage Delegate',
      description:
        "Delegation lets another user act on your behalf within scopes you already hold — it never changes anyone's primary role.",
    },
  },
  {
    path: 'provider/delegation-activities',
    component: ProviderActivitiesComponent,
    canActivate: [authGuard],
    data: {
      title: 'Delegate Activities',
      description:
        'Activities your delegates performed on assets and user actions.',
      hideComputeTab: true,
      actorType: 'DELEGATE',
    },
  },
  {
    path: 'provider/delegated-access',
    component: ProviderDelegateComponent,
    canActivate: [authGuard],
    data: {
      title: 'Delegated Access',
      description:
        'See the owners who granted you access and the scopes you can act on their behalf.',
      ownersOnly: true,
    },
  },
  {
    path: 'provider/my-projects',
    component: ProviderMyProjectsComponent,
    canActivate: [authGuard],
    canDeactivate: [MyProjectsDeactivateGuard],
    data: {
      title: 'My Projects',
      description: 'Manage and view all your projects',
    },
  },
  {
    path: 'provider/requests',
    component: ProviderMyRequestComponent,
    canActivate: [authGuard],
    data: {
      title: 'Asset Management',
      description: 'View and Manage your access requests',
    },
  },
  {
    path: 'provider/requests/:requestId/conversation',
    component: ConversationComponent,
    canActivate: [authGuard],
    data: {
      title: 'Conversation',
      description: 'Discuss your request directly with an asset owner.',
      panel: 'provider',
      role: 'requester',
      backRoute: '/provider/requests',
    },
  },
  {
    path: 'provider/add-contributions/add-dataset',
    component: ProviderAddDatasetComponent,
    canActivate: [authGuard],
    data: {
      title: 'Add Dataset',
      description: 'Add a new dataset to the repository',
    },
  },
  {
    path: 'provider/add-contributions/add-dataset/metadata',
    component: ProviderMetadataComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description:
        'Manually define your metadata by filling up the form. Add titles, descriptions, field types, and schema details.',
    },
  },
  {
    path: 'provider/add-contributions/add-dataset/upload-metadata',
    component: ProviderUploadMetadataComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description:
        'Upload a JSON schema to populate metadata fields automatically.',
    },
  },
  {
    path: 'provider/add-contributions/add-dataset/preview-metadata',
    component: ProviderPreviewMetadataComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description: 'Preview the uploaded metadata before proceeding.',
    },
  },
  {
    path: 'provider/add-contributions/add-dataset/additionalInfo',
    component: ProviderAdditionalInfoComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description: 'Provide additional information about your dataset',
    },
  },
  {
    path: 'provider/add-contributions/add-dataset/uploads',
    component: ProviderUploadComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description: 'Upload your dataset using one of the available methods',
    },
  },
  {
    path: 'provider/add-dataset-new',
    component: ProviderAddDatasetNewComponent,
    canActivate: [authGuard],
    data: {
      title: 'Add Dataset',
      description: 'Dataset onboarding (shared library flow)',
    },
  },
  {
    path: 'provider/add-contributions/add-model',
    component: ProviderAddModelComponent,
    canActivate: [authGuard],
    data: {
      title: 'Add Model',
      description: 'Add a new model to the repository',
    },
  },
  {
    path: 'provider/add-contributions/add-model/metadata',
    redirectTo: 'provider/add-contributions/add-model',
    pathMatch: 'full',
  },
  {
    path: 'provider/add-contributions/add-model/upload-metadata',
    redirectTo: 'provider/add-contributions/add-model',
    pathMatch: 'full',
  },
  {
    path: 'provider/add-contributions/add-model/preview-metadata',
    redirectTo: 'provider/add-contributions/add-model',
    pathMatch: 'full',
  },
  {
    path: 'provider/add-contributions/add-model/additionalInfo',
    redirectTo: 'provider/add-contributions/add-model',
    pathMatch: 'full',
  },
  {
    path: 'provider/add-contributions/add-model/uploads',
    redirectTo: 'provider/add-contributions/add-model',
    pathMatch: 'full',
  },
  {
    path: 'provider/add-contributions/dataset/metadata',
    component: ProviderMetadataComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description:
        'Manually define your metadata by filling up the form. Add titles, descriptions, field types, and schema details.',
    },
  },
  {
    path: 'provider/add-contributions/dataset/additionalInfo',
    component: ProviderAdditionalInfoComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description: 'Provide additional information about your dataset',
    },
  },
  {
    path: 'provider/add-contributions/dataset/uploads',
    component: ProviderUploadComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description: 'Upload your dataset using one of the available methods',
    },
  },
  {
    path: 'provider/manage-contributions',
    component: ProviderManageContributionComponent,
    canActivate: [authGuard],
    data: {
      title: 'Assets',
      description: 'View and manage all your contributed assets',
    },
  },
  {
    path: 'provider/add-policy',
    component: AddPolicyHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Add New Policy',
      description:
        'Create a policy with constraints and expiry for a dataset or model',
    },
  },
  {
    path: 'provider/access-requests',
    component: ProviderAccessRequestsComponent,
    canActivate: [authGuard],
    data: {
      title: 'Access Policy',
      description: 'Review and manage organisation access policies.',
    },
  },
  {
    path: 'provider/access-requests/:requestId/conversation',
    component: ConversationComponent,
    canActivate: [authGuard],
    data: {
      title: 'Conversation',
      description: 'Discuss the request directly with the requestor.',
      panel: 'provider',
      role: 'owner',
      backRoute: '/provider/access-requests?tab=assetRequest',
    },
  },
  {
    path: 'provider/data-provider-entity',
    component: ProviderDataProviderEntityComponent,
    canActivate: [authGuard],
    data: {
      title: 'Organisation',
      description: 'View your Organisation details',
    },
  },
  {
    path: 'provider/support',
    component: ProviderSupportComponent,
    canActivate: [authGuard],
    data: {
      title: 'Support Center',
      description:
        'Get help and find resources to make the most of your experience',
    },
  },
  {
    path: 'org-admin',
    component: RoleRedirectComponent,
    // Note: authGuard is not needed here as RoleRedirectComponent handles authentication
    // and redirects unauthenticated users to home page
  },
  {
    path: 'org-admin/home',
    component: OrgAdminHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Dashboard',
      description: 'Welcome !!',
    },
  },
  {
    path: 'org-admin/dashboard',
    component: OrgAdminDashboardComponent,
    canActivate: [authGuard],
    data: {
      title: 'Dashboard',
      description: 'Org Admin dashboard overview',
    },
  },
  {
    path: 'org-admin/activities',
    component: OrgAdminActivitiesComponent,
    canActivate: [authGuard],
    data: {
      title: 'My Activities',
      description:
        'Shows the list of activities that the logged-in user has performed across the platform.',
    },
  },
  {
    path: 'org-admin/add-contributions',
    component: OrgAdminAddContributionsComponent,
    canActivate: [authGuard],
    data: {
      title: 'Add Contributions',
      description: 'Add new contributions to the platform',
    },
  },
  {
    path: 'org-admin/add-dataset',
    component: OrgAdminAddDatasetComponent,
    canActivate: [authGuard],
    data: {
      title: 'Add Dataset',
      description: 'Add a new dataset to the repository',
    },
  },
  {
    path: 'org-admin/add-dataset-new',
    component: OrgAdminAddDatasetNewComponent,
    canActivate: [authGuard],
    data: {
      title: 'Add Dataset',
      description: 'Dataset onboarding (shared library flow)',
    },
  },
  {
    path: 'org-admin/add-dataset/metadata',
    component: ProviderMetadataComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description:
        'Manually define your metadata by filling up the form. Add titles, descriptions, field types, and schema details.',
    },
  },
  {
    path: 'org-admin/add-dataset/upload-metadata',
    component: ProviderUploadMetadataComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description:
        'Upload a JSON schema to populate metadata fields automatically.',
    },
  },
  {
    path: 'org-admin/add-dataset/preview-metadata',
    component: ProviderPreviewMetadataComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description: 'Preview the uploaded metadata before proceeding.',
    },
  },
  {
    path: 'org-admin/add-dataset/additionalInfo',
    component: ProviderAdditionalInfoComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description: 'Provide additional information about your dataset',
    },
  },
  {
    path: 'org-admin/add-dataset/uploads',
    component: ProviderUploadComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Dataset',
      description: 'Upload your dataset using one of the available methods',
    },
  },
  {
    path: 'org-admin/add-model',
    component: OrgAdminAddModelComponent,
    canActivate: [authGuard],
    data: {
      title: 'Add Model',
      description: 'Add a new model to the repository',
    },
  },
  {
    path: 'org-admin/add-model/metadata',
    redirectTo: 'org-admin/add-model',
    pathMatch: 'full',
  },
  {
    path: 'org-admin/add-model/upload-metadata',
    redirectTo: 'org-admin/add-model',
    pathMatch: 'full',
  },
  {
    path: 'org-admin/add-model/preview-metadata',
    redirectTo: 'org-admin/add-model',
    pathMatch: 'full',
  },
  {
    path: 'org-admin/add-model/additionalInfo',
    redirectTo: 'org-admin/add-model',
    pathMatch: 'full',
  },
  {
    path: 'org-admin/add-model/uploads',
    redirectTo: 'org-admin/add-model',
    pathMatch: 'full',
  },
  {
    path: 'org-admin/mdm',
    component: OrgAdminMdmComponent,
    canActivate: [authGuard],
    data: {
      title: 'MDM',
      description: 'Master Data Management',
    },
  },
  {
    path: 'org-admin/delegate',
    component: OrgAdminDelegateComponent,
    canActivate: [authGuard],
    data: {
      title: 'Manage Delegate',
      description:
        "Delegation lets another user act on your behalf within scopes you already hold — it never changes anyone's primary role.",
    },
  },
  {
    path: 'org-admin/delegation-activities',
    component: OrgAdminActivitiesComponent,
    canActivate: [authGuard],
    data: {
      title: 'Delegate Activities',
      description:
        'Activities your delegates performed on assets and user actions.',
      hideComputeTab: true,
      actorType: 'DELEGATE',
    },
  },
  {
    path: 'org-admin/delegated-access',
    component: OrgAdminDelegateComponent,
    canActivate: [authGuard],
    data: {
      title: 'Delegated Access',
      description:
        'See the owners who granted you access and the scopes you can act on their behalf.',
      ownersOnly: true,
    },
  },
  {
    path: 'org-admin/my-projects',
    component: OrgAdminMyProjectsComponent,
    canActivate: [authGuard],
    canDeactivate: [MyProjectsDeactivateGuard],
    data: {
      title: 'My Projects',
      description: 'Manage and view all your projects',
    },
  },
  {
    path: 'org-admin/requests',
    component: OrgAdminMyRequestComponent,
    canActivate: [authGuard],
    data: {
      title: 'Asset Management',
      description: 'View and Manage your access requests',
    },
  },
  {
    path: 'org-admin/requests/:requestId/conversation',
    component: ConversationComponent,
    canActivate: [authGuard],
    data: {
      title: 'Conversation',
      description: 'Discuss your request directly with an asset owner.',
      panel: 'org-admin',
      role: 'requester',
      backRoute: '/org-admin/requests',
    },
  },
  {
    path: 'org-admin/view-all-users',
    component: OrgAdminViewAllUsersComponent,
    canActivate: [authGuard],
    data: {
      title: 'Organisation Users',
      description: 'View and manage all users',
    },
  },
  {
    path: 'org-admin/user-requests',
    component: UserRequestsHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'User Requests',
      description: 'View and manage user requests',
    },
  },
  {
    path: 'org-admin/user-requests/join-organisation-request',
    component: UserRequestsHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'User Requests',
      description: 'View and manage user requests',
    },
  },
  {
    path: 'org-admin/user-requests/role-upgradation-request',
    component: UserRequestsHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'User Requests',
      description: 'View and manage user requests',
    },
  },
  {
    path: 'org-admin/manage-contributions',
    component: OrgAdminManageContributionsComponent,
    canActivate: [authGuard],
    data: {
      title: 'Assets',
      description: 'View and manage assets contributed by your organization',
    },
  },
  {
    path: 'org-admin/add-policy',
    component: AddPolicyHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Add New Policy',
      description:
        'Create a policy with constraints and expiry for a dataset or model',
    },
  },
  {
    path: 'org-admin/access-requests',
    component: AccessRequestsHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Access Policy',
      description: 'Review and manage organisation access policies.',
    },
  },
  {
    path: 'org-admin/access-requests/:requestId/conversation',
    component: ConversationComponent,
    canActivate: [authGuard],
    data: {
      title: 'Conversation',
      description: 'Discuss the request directly with the requestor.',
      panel: 'org-admin',
      role: 'owner',
      backRoute: '/org-admin/access-requests?tab=assetRequest',
    },
  },
  {
    path: 'org-admin/organisation-activities',
    component: OrgAdminOrganisationActivitiesComponent,
    canActivate: [authGuard],
    data: {
      title: 'Organisation User Activities',
      description: 'View organisation user activities',
    },
  },
  {
    path: 'org-admin/data-provider-entity',
    component: OrgAdminDataProviderEntityComponent,
    canActivate: [authGuard],
    data: {
      title: 'Organisation',
      description: 'View your Organisation details',
    },
  },
  {
    path: 'org-admin/profile',
    component: OrgAdminProfileComponent,
    canActivate: [authGuard],
    data: {
      title: 'My Profile',
      description: 'Manage your account settings and preferences',
    },
  },
  {
    path: 'org-admin/support',
    component: OrgAdminSupportComponent,
    canActivate: [authGuard],
    data: {
      title: 'Support Center',
      description:
        'Get help and find resources to make the most of your experience',
    },
  },
  {
    path: 'admin',
    redirectTo: 'admin/home',
    pathMatch: 'full',
  },
  {
    path: 'admin/home',
    component: AdminHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Dashboard',
      description: 'Welcome !!',
    },
  },
  {
    path: 'admin/delegate',
    component: AdminDelegateComponent,
    canActivate: [authGuard],
    data: {
      title: 'Manage Delegate',
      description:
        "Delegation lets another user act on your behalf within scopes you already hold — it never changes anyone's primary role.",
    },
  },
  {
    path: 'admin/delegation-activities',
    component: AdminActivitiesComponent,
    canActivate: [authGuard],
    data: {
      title: 'Delegate Activities',
      description:
        'Activities your delegates performed on assets and user actions.',
      hideComputeTab: true,
      actorType: 'DELEGATE',
    },
  },
  {
    path: 'admin/delegated-access',
    component: AdminDelegateComponent,
    canActivate: [authGuard],
    data: {
      title: 'Delegated Access',
      description:
        'See the owners who granted you access and the scopes you can act on their behalf.',
      ownersOnly: true,
    },
  },
  {
    path: 'admin/dashboard',
    component: AdminDashboardComponent,
    canActivate: [authGuard],
    data: {
      title: 'Dashboard',
      description: 'Admin dashboard overview',
    },
  },
  {
    path: 'admin/analytics-dashboard',
    component: AdminSupersetDashboardComponent,
    canActivate: [authGuard],
    data: {
      title: 'Superset',
      description: 'Superset analytics and reporting',
    },
  },
  {
    path: 'admin/analytics-dashboard/:dashboardId',
    component: AdminSupersetDashboardComponent,
    canActivate: [authGuard],
    data: {
      title: 'Superset',
      description: 'Superset analytics and reporting',
    },
  },
  {
    path: 'admin/activities',
    component: AdminActivitiesComponent,
    canActivate: [authGuard],
    data: {
      title: 'My Activities',
      description:
        'View all the activities that user has performed across the platform.',
    },
  },
  {
    path: 'admin/user-activities',
    component: UserActivitiesHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'User Activities',
      description:
        'View the complete history of all user activities performed accross the platform.',
    },
  },
  {
    path: 'admin/add-contributions',
    component: UsecasesHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Create Use Case',
      description: 'Create a Use Case to inspire your next innovation.',
    },
  },
  {
    path: 'admin/view-all-users',
    component: AdminViewAllUsersComponent,
    canActivate: [authGuard],
    data: {
      title: 'View all platform Users',
      description: 'View and manage all users',
    },
  },
  {
    path: 'admin/credit-compute',
    component: ComputeCreditHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Compute Requests',
      description: 'View and manage compute role requests',
    },
  },
  {
    path: 'admin/access-requests',
    component: AdminAccessRequestsComponent,
    canActivate: [authGuard],
    data: {
      title: 'Access Requests',
      description: 'View and manage access requests',
    },
  },
  {
    path: 'admin/manage-feedback',
    component: AdminManageFeedbackComponent,
    canActivate: [authGuard],
    data: {
      title: 'Manage Feedback',
      description: 'Review and approve catalogue ratings and feedback',
    },
  },
  {
    path: 'admin/contributions',
    component: AdminContributionsComponent,
    canActivate: [authGuard],
    data: {
      title: 'Manage Platform Assets',
      description: 'View and manage all contributions',
    },
  },
  {
    path: 'admin/data-upload-requests',
    component: AdminDataUploadRequestsHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Asset File Upload',
      description: 'View and manage asset file upload requests',
    },
  },
  {
    path: 'admin/existing-entities',
    component: AdminExistingEntitiesComponent,
    canActivate: [authGuard],
    data: {
      title: 'Manage Organisations',
      description: 'View and manage manage organisations',
    },
  },
  {
    path: 'admin/new-requests',
    component: AdminNewRequestsComponent,
    canActivate: [authGuard],
    data: {
      title: 'Organisation Requests',
      description: 'View and manage Organisation requests',
    },
  },
  {
    path: 'admin/challenge',
    component: ChallengeHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Manage Challenge',
      description: 'Create, schedule, and manage platform challenges',
    },
    children: [
      { path: '', redirectTo: 'create', pathMatch: 'full' },
      {
        path: 'create',
        loadComponent: () =>
          import(
            './platform-admin/challenge/challenge-create/challenge-create.component'
          ).then((m) => m.ChallengeCreateComponent),
      },
      {
        path: 'scheduled',
        loadComponent: () =>
          import(
            './platform-admin/challenge/challenge-scheduled/challenge-scheduled.component'
          ).then((m) => m.ChallengeScheduledComponent),
      },
      {
        path: 'running',
        loadComponent: () =>
          import(
            './platform-admin/challenge/challenge-running/challenge-running.component'
          ).then((m) => m.ChallengeRunningComponent),
      },
      {
        path: 'evaluation',
        loadComponent: () =>
          import(
            './platform-admin/challenge/challenge-evaluation/challenge-evaluation.component'
          ).then((m) => m.ChallengeEvaluationComponent),
      },
      {
        path: 'completed',
        loadComponent: () =>
          import(
            './platform-admin/challenge/challenge-completed/challenge-completed.component'
          ).then((m) => m.ChallengeCompletedComponent),
      },
      {
        path: 'submissions',
        loadComponent: () =>
          import(
            './platform-admin/challenge/challenge-submissions/challenge-submissions.component'
          ).then((m) => m.ChallengeSubmissionsComponent),
      },
    ],
  },
  {
    path: 'admin/discussion',
    component: DiscussionHomeComponent,
    canActivate: [authGuard],
    data: {
      title: 'Manage Discussion',
      description: 'View Discussions, Review comments',
    },
  },
  {
    path: 'admin/profile',
    component: AdminProfileComponent,
    canActivate: [authGuard],
    data: {
      title: 'My Profile',
      description: 'Manage your account settings and preferences',
    },
  },
  {
    path: 'admin/support',
    component: AdminSupportComponent,
    canActivate: [authGuard],
    data: {
      title: 'Support Center',
      description:
        'Get help and find resources to make the most of your experience',
    },
  },
  {
    path: 'datasets',
    component: DatasetsComponent,
    data: {
      title: 'Datasets',
      description: 'Discover a rich repository of Agri-related data',
    },
  },
  {
    path: 'dataset/:id',
    component: DatasetDetailComponent,
    data: {
      title: 'Dataset Details',
      description: 'View detailed information about this dataset',
    },
  },
  {
    path: 'models',
    component: ModelsComponent,
    data: {
      title: 'Models',
      description: 'Explore, test, and contribute AI models',
    },
  },
  {
    path: 'model/:id',
    component: ModelDetailComponent,
    data: {
      title: 'Model Details',
      description: 'View detailed information about this model',
    },
  },
  {
    path: 'usecases',
    component: UsecasesComponent,
    data: {
      title: 'Use Cases',
      description: 'Access usecase library to inspire your next innovation',
    },
  },
  {
    path: 'leaderboard',
    component: LeadershipComponent,
    data: {
      title: 'Leaderboard',
      description: 'Meet our leadership team',
    },
  },
  {
    path: 'leadership',
    redirectTo: 'leaderboard',
    pathMatch: 'full',
  },
  {
    path: 'usecase/:id',
    redirectTo: 'usecases',
    pathMatch: 'full',
  },
  {
    path: 'about-mahaagx',
    component: AboutUsHomeComponent,
    data: {
      title: 'About MahaAgX',
      description: 'Learn about the MahaAgX platform',
    },
  },
  {
    path: 'about',
    redirectTo: 'about-mahaagx',
    pathMatch: 'full',
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
    data: {
      title: 'Privacy Policy',
      description:
        'MahaAgX Privacy Policy - Learn how we collect, use, and protect your data',
    },
  },
  {
    path: 'terms-of-service',
    component: TermsOfServiceComponent,
    data: {
      title: 'Terms of Service',
      description:
        'MahaAgX Terms of Service - Framework and guidelines for using the platform',
    },
  },
  {
    path: 'contact-us',
    component: ContactUsComponent,
    canActivate: [authGuard],
    data: {
      title: 'Contact Us',
      description: 'Get in touch with the MahaAgX team',
    },
  },
  {
    path: 'user-manual',
    component: UserManualOverviewComponent,
    data: {
      title: 'User Manual',
      description: 'Comprehensive guide for the MahaAgX platform',
    },
  },
  {
    path: 'user-manual/:sectionId',
    component: UserManualSectionComponent,
    data: {
      title: 'User Manual Section',
      description: 'View selected user manual section',
    },
  },
  {
    path: 'contact-us/thank-you',
    component: ContactThankYouComponent,
    canActivate: [authGuard],
    data: {
      title: 'Thank you - Contact Us',
      description: 'Thank you for contacting MahaAgX',
    },
  },
  {
    path: 'sandbox',
    component: SandboxComponent,
    data: {
      title: 'Sandbox',
      description: 'Explore and experiment with our data platform',
    },
  },
  {
    path: 'toolset',
    component: ToolkitComponent,
    data: {
      title: 'Toolset',
      description:
        'A curated collection of open-source tools for data science, ML, and AI development',
    },
  },
  {
    path: 'knowledge-library',
    component: KnowledgeHubComponent,
    data: {
      title: 'Knowledge hub',
      description: 'Browse the knowledge base and curated content',
    },
  },
  {
    path: 'knowledge-hub',
    redirectTo: 'knowledge-library',
    pathMatch: 'full',
  },
  {
    path: 'library',
    component: LibrariesComponent,
    data: {
      title: 'Library',
      description:
        'Learning resources: articles and videos for agri-data solutions',
    },
  },
  {
    path: 'challenges',
    component: ChallengesHomeComponent,
    data: {
      title: 'Challenges',
      description: 'Explore and participate in agricultural challenges',
    },
  },
  {
    path: 'challenges/demo',
    component: ChallengeCardDemoComponent,
    data: {
      title: 'Challenge Card Design Demo',
      description: 'Compare challenge card design options',
    },
  },
  {
    path: 'challenges/:id',
    component: ChallengeDetailComponent,
    data: {
      title: 'Challenge Details',
      description: 'View detailed information about this challenge',
    },
  },
  {
    path: 'discussions',
    redirectTo: 'discussions/getting-started',
    pathMatch: 'full',
  },
  {
    path: 'discussions/getting-started',
    component: DiscussionGettingStartedComponent,
    data: {
      title: 'Getting Started',
      description: 'Welcome to MahaAgX Discussions',
    },
  },
  {
    path: 'discussions/public',
    component: DiscussionPublicComponent,
    data: {
      title: 'Public Discussions',
      description: 'Join public discussions',
    },
  },
  {
    path: 'discussions/general',
    component: DiscussionGeneralComponent,
    data: {
      title: 'General Discussions',
      description: 'General discussion topics',
    },
  },
  {
    path: 'discussions/feedback',
    component: DiscussionFeedbackComponent,
    data: {
      title: 'Feedback',
      description: 'Share your feedback',
    },
  },
  {
    path: 'discussions/announcement',
    component: DiscussionAnnouncementComponent,
    data: {
      title: 'Announcements',
      description: 'Latest announcements',
    },
  },
  {
    path: 'discussions/my-discussions',
    component: DiscussionMyDiscussionsComponent,
    data: {
      title: 'My Discussions',
      description: 'View your discussions',
    },
  },
  {
    path: 'discussions/my-bookmarks',
    component: DiscussionMyBookmarksComponent,
    data: {
      title: 'My Bookmarks',
      description: 'View your bookmarked discussions',
    },
  },
  {
    path: 'discussions/my-pinned',
    component: DiscussionMyPinnedComponent,
    data: {
      title: 'My Pinned',
      description: 'View your pinned discussions',
    },
  },
  {
    path: 'discussions/post-submission',
    component: DiscussionPostSubmissionComponent,
    data: {
      title: 'Post Submission',
      description: 'View your submitted discussions',
    },
  },
  {
    path: 'discussions/create-new',
    component: DiscussionCreateComponent,
    data: {
      title: 'Create Discussion',
      description: 'Start a new discussion',
    },
  },
  {
    path: 'discussions/:id',
    component: DiscussionDetailComponent,
    data: {
      title: 'Discussion Details',
      description: 'View discussion details',
    },
  },
  {
    path: 'canvas',
    canActivate: [authGuard],
    loadChildren: () =>
      import('@angular-workspace/feature/canvas').then((m) => m.CanvasRoutes),
  },
  {
    path: '',
    component: LandingComponent,
  },
  // Catch-all for unknown routes (e.g. user enters dummy URL)
  // Redirect to landing page instead of showing a blank view.
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

for (const route of appRoutes) {
  if (!route.path || route.redirectTo != null) continue;
  if (!isDelegateRestrictedPath(`/${route.path}`)) continue;
  route.canActivate = [
    ...(route.canActivate ?? []),
    delegateRestrictedRouteGuard,
  ];
}
